import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent implements OnInit {
  @Input()
  dark: boolean;

  @Input()
  noShadows: boolean;

  @Input()
  transparent: boolean;

  @Input()
  header: string;

  @Input()
  subHeader: string;

  @Input()
  noMarginBottom: boolean;

  @Input()
  noMarginTop: boolean;

  @Input()
  noMargins: boolean;

  @Input()
  noPadding: boolean;

  @Input()
  noBorders: boolean;

  @Input()
  action?: string;

  @Input()
  actionActive: boolean;

  @Output()
  readonly activated = new EventEmitter<any>();

  @Input()
  removePadding: boolean;

  @Input()
  removeAllPadding: boolean;

  @Input()
  addHeaderMargin: boolean;

  @Input()
  tagColor: string;

  @Input()
  tagText: string;

  containerClasses: string[];

  paddingClasses = '';
  padding = 'noBottomPadding';
  headerClasses = '';

  ngOnInit() {
    this.setPaddingClasses();
    this.setContainerClasses();
    this.setMarginClasses();
  }

  setContainerClasses() {
    this.containerClasses = [
      '_container',
      this.paddingClasses,
      this.dark ? 'dark-background' : '',
      this.noMarginBottom ? 'no-margin-bottom' : '',
      this.noMarginTop ? 'no-margin-top' : '',
      this.noMargins ? 'no-margins' : '',
      this.noShadows ? 'no-shadows' : '',
      this.noPadding ? 'no-padding' : '',
      this.noBorders ? 'no-borders' : '',
    ];
  }

  setMarginClasses() {
    if (this.addHeaderMargin) {
      this.headerClasses = 'header-margins';
    }
  }

  setPaddingClasses() {
    if (this.removePadding) {
      this.paddingClasses = this.padding;
    }
    if (this.removeAllPadding) {
      this.paddingClasses = 'no-padding';
    }
  }

  activate(event) {
    this.activated.emit(event);
  }
}
